import { render, staticRenderFns } from "./DocumentPageEditor.vue?vue&type=template&id=1f9fdaae&scoped=true&"
import script from "./DocumentPageEditor.vue?vue&type=script&lang=ts&"
export * from "./DocumentPageEditor.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentPageEditor.vue?vue&type=style&index=0&id=1f9fdaae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9fdaae",
  null
  
)

export default component.exports